import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import CalculationForm from './CalculationForm';


const CalculationSection = (props) => {

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="wpo-calculation-section-wrapper" >
                    <div className="row align-items-center">
                        <div className="col-lg-4">
                            <SectionTitle subtitle={'Get A Quote'} title={'Fill the enquiry form to get best pricing.'} />
                        </div>
                        <div className="col-lg-8 col-md-12 col-12">
                            <CalculationForm />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-boy">
                <img src={props.Boy} alt="" height='450px' />
            </div>
        </section>
    );
};

export default CalculationSection;